import { NETWORK_CHAIN_IDS } from "./network-chain-ids";

export const ETHERSCAN_URLS = {
  [NETWORK_CHAIN_IDS.GOERLI]: "https://goerli.etherscan.io",
  [NETWORK_CHAIN_IDS.MAINNET]: "https://etherscan.io",
};

export const SMART_CONTRACT_ADDRESS = process.env.SMART_CONTRACT_ADDRESS;
